// @core/api/endpoints/activity/get_activity_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetActivitySettingsResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Get activity settings
 * Returns the current user's activity and inbox preferences: grouping, default filters, scope subscriptions.
 */
export async function GetActivitySettings(
  params?: {
  },
  options?: RequestOptions
): Promise<GetActivitySettingsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/activity-settings`;
  const requestOptions = options;
  return client.get<GetActivitySettingsResponse>(requestPath, { ...requestOptions, params });
}
